import { useEffect, useState } from 'react';
import axios from 'axios';

const useStrategyData = (accountIdOrIds, isRecent) => {
  const [strategyData, setStrategyData] = useState([]);
  const [logoMap, setLogoMap] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const ids = Array.isArray(accountIdOrIds) ? accountIdOrIds : [accountIdOrIds];

    let cancelled = false;
    setLoading(true);

    // pobierz strategie dla wszystkich kont równolegle
    Promise.allSettled(
      ids.map(id =>
        axios
          .get(`${process.env.REACT_APP_DEV_SERVER}/strategy/${id}`)
          .then(res => res.data || [])
      )
    )
      .then(results => {
        if (cancelled) return;

        // spłaszcz wyniki, pomiń odrzucone
        const merged = results
          .filter(r => r.status === 'fulfilled')
          .flatMap(r => r.value);

        setStrategyData(merged);
      })
      .catch(() => {
        if (!cancelled) setStrategyData([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
    // ważne: stabilna zależność
  }, [JSON.stringify(accountIdOrIds)]);

  // dogrywanie logotypów na podstawie zebranych symboli
  useEffect(() => {
    const symbols = [
      ...new Set(
        strategyData
          .filter(s => typeof s.symbol === 'string')
          .map(s => (s.symbol.includes('/') ? s.symbol.split('/')[0] : s.symbol).toLowerCase())
      )
    ];

    const toFetch = symbols.filter(sym => !logoMap[sym]);
    if (!toFetch.length) return;

    let cancelled = false;

    Promise.all(
      toFetch.map(sym =>
        axios
          .get(`${process.env.REACT_APP_DEV_SERVER}/logo/${sym}`)
          .then(res => ({ sym, logoUrl: res.data?.logoUrl }))
          .catch(() => null)
      )
    ).then(results => {
      if (cancelled) return;
      const newLogos = {};
      results.forEach(r => {
        if (r && r.logoUrl) newLogos[r.sym] = r.logoUrl;
      });
      if (Object.keys(newLogos).length) {
        setLogoMap(prev => ({ ...prev, ...newLogos }));
      }
    });

    return () => {
      cancelled = true;
    };
  }, [strategyData, logoMap]);

  // filtrowanie „ostatnie 24h” vs „starsze”
  const filteredStrategies = strategyData.filter(strategy => {
    const hoursDiff = (new Date() - new Date(strategy.updatedAt)) / 1000 / 60 / 60;
    return isRecent ? hoursDiff <= 24 : hoursDiff > 24;
  });

  const totalWithdrawableProfit = filteredStrategies.reduce(
    (sum, s) => sum + parseFloat(s.withdrawable_profit || 0),
    0
  );

  return { filteredStrategies, logoMap, loading, totalWithdrawableProfit };
};

export default useStrategyData;
